document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-product-thumbnail]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('[data-product-main-image]');
      const src = thumb.dataset.src;
      const alt = thumb.dataset.alt || '';
      if (main && src) {
        main.src = src;
        main.alt = alt;
      }
    });
  });
});
